const prefix = "LOOKUP_";

export const LOAD_STATIC_LOOKUPS = prefix + "LOAD_STATIC_LOOKUPS";
export const LOAD_DYNAMIC_LOOKUPS = prefix + "LOAD_DYNAMIC_LOOKUPS";
